import { mainService, boxService, emmaApiService } from '@/shared/api/services'

export const middleware = [mainService.middleware,emmaApiService.middleware, boxService.middleware]